import { add, any, equals, filter, flatten, gte, indexOf, map, not, pipe, prop, propOr, sum, when } from 'ramda';

import { LANDING_THEMES } from 'utils/itineraries/functions';

import { IGetPageHeaderHeightParams, IGetHeaderHeightDefaultParams, IGetBlockStickyTopOffset } from './types';

// @ts-ignore
const checkIsStickyElement = pipe(prop('classList'), any(pipe(indexOf('sticky'), equals(-1), not)));

const MIN_TOOLBAR_OFFSET = 15;

// (string#element id) => int#summ of height all sticky childs
export const getToolbarOffset = pipe(
  (id) => document.getElementById(id),
  propOr([], 'childNodes'),
  // @ts-ignore
  Array.from,
  filter(checkIsStickyElement as any),
  map((htmlElement: HTMLElement) => htmlElement.getClientRects()),
  map(map((val: { height: number }) => val?.height || 0)),
  flatten,
  sum,
  when(gte(MIN_TOOLBAR_OFFSET), add(MIN_TOOLBAR_OFFSET)),
);

const getHeaderHeightDefault = ({
  isTabletOrMobile,
  landingTheme,
  pageHeaderElem,
  isPortal,
}: IGetHeaderHeightDefaultParams) => {
  const pageHeaderRect: DOMRect | {} =
    pageHeaderElem && pageHeaderElem instanceof Element ? pageHeaderElem.getBoundingClientRect() : {};
  const height: number = 'height' in pageHeaderRect ? pageHeaderRect.height : 0;

  if (!isTabletOrMobile && landingTheme !== LANDING_THEMES.nomad && isPortal) {
    return height + 42;
  }
  return height;
};

export const getBlockStickyTopOffset = (
  rect: DOMRect,
  {
    getHeaderHeight = getHeaderHeightDefault,
    pageHeaderElem,
    mobileNavElem,
    landingTheme,
    isTabletOrMobile,
    isPortal,
  }: IGetBlockStickyTopOffset,
) => {
  const mobileNavRect: DOMRect | {} = mobileNavElem ? mobileNavElem.getBoundingClientRect() : {};
  let x = 2;
  const currentPageHeadlineHeight = rect?.height || 0;
  const pageHeaderHeight = getHeaderHeight({ isTabletOrMobile, landingTheme, pageHeaderElem, isPortal });

  const mobileNavHeight = 'height' in mobileNavRect ? mobileNavRect.height : 0;
  const sum = isTabletOrMobile ? mobileNavHeight : currentPageHeadlineHeight;
  return sum + pageHeaderHeight - x;
};

export const getPageHeaderHeight = ({
  isTabletOrMobile,
  landingTheme,
  pageHeaderElem,
  isPortal,
}: IGetPageHeaderHeightParams) => {
  return getHeaderHeightDefault({ isTabletOrMobile, landingTheme, pageHeaderElem, isPortal });
};
